// Place order on the cart page: confirm the delivery address, then place the
// order through yene.checkout.submit_order.
//
// A bundle (hooks.py loads "cart_override.bundle.js"), so every build gets a
// new file name. As a plain /assets/yene/js file browsers kept it for 12 hours,
// and a checkout fix did not reach anyone holding the previous copy.
frappe.provide("yene.checkout");

frappe.ready(function () {
    if (window.location.pathname && window.location.pathname.indexOf("/cart") === 0) {
        // Ensure default handler is removed and our handler is bound
        const bindHandlers = () => {
            try {
                // For default core button
                $('.btn-place-order').off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const btn = this;
                    yene.checkout.check_and_handle_addresses(btn);
                });
                // For our custom button
                $(document).off('click', '#yene-place-order').on('click', '#yene-place-order', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const btn = this;
                    yene.checkout.check_and_handle_addresses(btn);
                });
            } catch (err) {
                console.warn('Yene bindHandlers error', err);
            }
        };

        // Bind now and after a short delay to catch any dynamic rendering
        bindHandlers();
        setTimeout(bindHandlers, 300);
        setTimeout(bindHandlers, 1000);
    }
});

// Check addresses and proceed accordingly
yene.checkout.check_and_handle_addresses = function(btn) {
    // Disable button to prevent double clicks
    $(btn).prop('disabled', true).addClass('disabled');
    
    frappe.call({
        method: "yene.overrides.webshop_cart.get_customer_addresses",
        callback: function(r) {
            // Re-enable button after response
            $(btn).prop('disabled', false).removeClass('disabled');
            
            if (r.message && r.message.length === 1) {
                // Exactly 1 address, use it directly as shipping & billing without prompt
                yene.checkout.set_addresses_and_place_order(btn, r.message[0].name, r.message[0].name);
            } else if (r.message && r.message.length > 1) {
                // User has multiple addresses, show selection dialog
                yene.checkout.show_address_dialog(btn, r.message);
            } else {
                // No addresses, show create address dialog
                yene.checkout.show_new_address_dialog(btn);
            }
        },
        error: function() {
            // Re-enable button on error
            $(btn).prop('disabled', false).removeClass('disabled');
            // Still safe to submit: the server asks for an address when the
            // cart has none of the customer's.
            yene.checkout.submit_order(btn);
        }
    });
};

// The server found none of the customer's addresses on the cart. Always ask:
// setting an address and submitting again by ourselves could get the same
// answer forever.
yene.checkout.handle_shipping_address_requirement = function(btn, addresses) {
    if (addresses && addresses.length) {
        yene.checkout.show_address_dialog(btn, addresses);
    } else {
        yene.checkout.show_new_address_dialog(btn);
    }
};

// Places the order and goes to it. place_order is yene's
// (yene.overrides.webshop_cart), or yene_multi_vendor's where that app is
// installed (registered after yene's; the last registration wins). Between
// them they answer in three shapes:
//
//   "SAL-ORD-0001"                          one order
//   {requires_shipping_address, addresses}  no address of the customer's
//   {orders: [{company, sales_order}], name} yene_multi_vendor only: the cart
//                                           split into one order per vendor
//                                           (on some versions also a single
//                                           order in another company)
//
// Webshop's own place_order sends the browser to "/orders/" + the answer, so
// both objects ended on /orders/[object Object]. Only an order name goes into
// a URL here.
yene.checkout.submit_order = function(btn) {
    const cart = webshop.webshop.shopping_cart;

    // Placing an order is not idempotent: never let two submits overlap.
    if (yene.checkout._submitting) return;
    yene.checkout._submitting = true;

    const recover = () => {
        yene.checkout._submitting = false;
        cart.unfreeze();
        $(btn).prop('disabled', false).removeClass('disabled');
    };

    cart.freeze();
    $(btn).prop('disabled', true).addClass('disabled');
    $("#cart-error").empty().toggle(false);

    frappe.call({
        type: "POST",
        method: "webshop.webshop.shopping_cart.cart.place_order",
        callback: function(r) {
            const result = r.message;

            if (r.exc) {
                recover();
                return;
            }

            if (typeof result === "string" && result) {
                window.location.href = "/orders/" + encodeURIComponent(result);
                return;
            }

            if (result && result.requires_shipping_address) {
                recover();
                yene.checkout.handle_shipping_address_requirement(btn, result.addresses);
                return;
            }

            const orders = (result && result.orders) || [];
            if (orders.length === 1) {
                window.location.href = "/orders/" + encodeURIComponent(orders[0].sales_order);
                return;
            }
            if (orders.length > 1) {
                // One order per vendor; the list shows them all at the top.
                window.location.href = "/orders";
                return;
            }

            recover();
            yene.checkout.show_error(__("Could not place the order. Please try again."));
        }
    }).fail(function(xhr) {
        // The website frappe.call never runs `error:`; a refusal lands here,
        // its message already shown by frappe. Say something only when the
        // server sent none (a crash).
        recover();
        if (!(xhr && xhr.responseJSON && xhr.responseJSON._server_messages)) {
            yene.checkout.show_error(__("Something went wrong!"));
        }
    });
};

yene.checkout.show_error = function(message) {
    const $error = $("#cart-error");
    if ($error.length) {
        $error.empty().html(message).toggle(true);
    } else {
        frappe.msgprint(message);
    }
};

yene.checkout.get_addresses = function () {
    return new Promise((resolve, reject) => {
        frappe.call({
            method: "frappe.contacts.doctype.address.address.get_address_display",
            args: { 
                "address_list": frappe.boot.website_data.addresses 
                    ? frappe.boot.website_data.addresses.map(d => d.name).join(",") 
                    : "" 
            },
            callback: (r) => r.message ? resolve(r.message) : reject(r),
            error: (r) => reject(r)
        });
    });
};

yene.checkout.update_cart = function (args) {
    return new Promise((resolve, reject) => {
        frappe.call({
            method: "webshop.webshop.shopping_cart.cart.update_cart",
            args: { "docname": frappe.boot.website_data.shopping_cart.name, ...args },
            callback: (r) => resolve(r.message),
            error: (r) => reject(r)
        });
    });
};

yene.checkout.add_address = function (address_values) {
    return new Promise((resolve, reject) => {
        frappe.call({
            method: "webshop.webshop.shopping_cart.cart.add_new_address",
            args: { "doc": address_values },
            callback: (r) => {
                if (r.message) {
                    // Update the boot data if it exists
                    if (frappe.boot.website_data && frappe.boot.website_data.addresses) {
                        frappe.boot.website_data.addresses.push({ 
                            name: r.message.name, 
                            title: address_values.address_title 
                        });
                    }
                    resolve(r.message.name);
                } else { 
                    reject(r); 
                }
            },
            error: (r) => reject(r)
        });
    });
};

yene.checkout.set_addresses_and_place_order = function(btn, shipping_address, billing_address) {
    // Disable button during processing
    $(btn).prop('disabled', true).addClass('disabled');
    
    // First set shipping address using update_cart_address
    frappe.call({
        method: "webshop.webshop.shopping_cart.cart.update_cart_address",
        args: {
            address_type: "shipping",
            address_name: shipping_address,
        },
        callback: () => {
            // Then set billing address
            frappe.call({
                method: "webshop.webshop.shopping_cart.cart.update_cart_address",
                args: {
                    address_type: "billing",
                    address_name: billing_address,
                },
                callback: () => {
                    yene.checkout.submit_order(btn);
                },
                error: (r) => {
                    // Re-enable button on error
                    $(btn).prop('disabled', false).removeClass('disabled');
                    frappe.msgprint(__("Could not set billing address. Please try again."));
                    console.error(r);
                }
            });
        },
        error: (r) => {
            // Re-enable button on error
            $(btn).prop('disabled', false).removeClass('disabled');
            frappe.msgprint(__("Could not set shipping address. Please try again."));
            console.error(r);
        }
    });
};

yene.checkout.show_address_dialog = function (btn, addresses) {
    const address_options = addresses.map(addr => {
        // Build label parts, filtering out empty values
        const parts = [];
        if (addr.address_title) parts.push(addr.address_title);
        if (addr.address_line1) parts.push(addr.address_line1);
        if (addr.city) parts.push(addr.city);
        
        // If no parts, use the name as fallback
        const label = parts.length > 0 ? parts.join(' - ') : addr.name;
        
        return {
            label: label,
            value: addr.name
        };
    });

    const dialog = new frappe.ui.Dialog({
        title: __("Select Shipping Address"),
        fields: [
            { 
                label: __("Shipping Address"), 
                fieldname: "shipping_address", 
                fieldtype: "Select", 
                options: address_options, 
                reqd: 1 
            },
            { 
                fieldtype: "Button", 
                label: __("Add New Address"), 
                click: () => { 
                    dialog.hide(); 
                    yene.checkout.show_new_address_dialog(btn); 
                } 
            },
            { 
                label: __("Use same address for billing"), 
                fieldname: "same_for_billing", 
                fieldtype: "Check", 
                default: 1 
            }
        ],
        primary_action_label: __("Continue"),
        primary_action: async (values) => {
            dialog.get_primary_btn().prop('disabled', true);
            dialog.hide();

            if (values.same_for_billing) {
                yene.checkout.set_addresses_and_place_order(btn, values.shipping_address, values.shipping_address);
            } else {
                yene.checkout.show_billing_address_dialog(btn, addresses, values.shipping_address);
            }
        }
    });
    dialog.show();
};

yene.checkout.show_billing_address_dialog = function (btn, addresses, shipping_address) {
    const address_options = addresses.map(addr => {
        // Build label parts, filtering out empty values
        const parts = [];
        if (addr.address_title) parts.push(addr.address_title);
        if (addr.address_line1) parts.push(addr.address_line1);
        if (addr.city) parts.push(addr.city);
        
        // If no parts, use the name as fallback
        const label = parts.length > 0 ? parts.join(' - ') : addr.name;
        
        return {
            label: label,
            value: addr.name
        };
    });

    const dialog = new frappe.ui.Dialog({
        title: __("Select Billing Address"),
        fields: [
            { 
                label: __("Billing Address"), 
                fieldname: "billing_address", 
                fieldtype: "Select", 
                options: address_options, 
                reqd: 1 
            },
            { 
                fieldtype: "Button", 
                label: __("Add New Address"), 
                click: () => { 
                    dialog.hide(); 
                    yene.checkout.show_new_address_dialog(btn, true, shipping_address); 
                } 
            }
        ],
        primary_action_label: __("Place Order"),
        primary_action: (values) => {
            dialog.get_primary_btn().prop('disabled', true);
            dialog.hide();
            yene.checkout.set_addresses_and_place_order(btn, shipping_address, values.billing_address);
        }
    });
    dialog.show();
};

yene.checkout.show_new_address_dialog = function (btn, for_billing = false, shipping_address = null) {
    const dialog = new frappe.ui.Dialog({
        title: __("Add New Address"),
        fields: [
            { label: __('Title'), fieldname: 'address_title', fieldtype: 'Data', reqd: 1 },
            { label: __('Address'), fieldname: 'address_line1', fieldtype: 'Data', reqd: 1 },
            { label: __('City'), fieldname: 'city', fieldtype: 'Data', reqd: 1 },
            { label: __('Country'), fieldname: 'country', fieldtype: 'Link', options: 'Country', reqd: 1, default: 'Ethiopia', only_select: 1 },
            { label: __('Phone'), fieldname: 'phone', fieldtype: 'Data', reqd: 1 },
            { 
                label: __("Use same address for billing"), 
                fieldname: "same_for_billing", 
                fieldtype: "Check", 
                default: 1, 
                hidden: for_billing 
            },
            // Hidden field for address type - always set to Shipping
            { fieldname: 'address_type', fieldtype: 'Select', options: 'Shipping\nBilling', default: 'Shipping', hidden: 1 }
        ],
        primary_action_label: __("Save and Continue"),
        primary_action: async (values) => {
            dialog.get_primary_btn().prop('disabled', true);
            
            // Add customer linking fields
            values.link_doctype = "Customer";
            values.link_name = frappe.session.customer;
            
            try {
                const address_name = await yene.checkout.add_address(values);
                dialog.hide();

                if (for_billing) {
                    yene.checkout.set_addresses_and_place_order(btn, shipping_address, address_name);
                } else {
                    if (values.same_for_billing) {
                        yene.checkout.set_addresses_and_place_order(btn, address_name, address_name);
                    } else {
                        // Need to get updated addresses and show billing dialog
                        const addresses = await yene.checkout.get_customer_addresses_for_dialog();
                        yene.checkout.show_billing_address_dialog(btn, addresses, address_name);
                    }
                }
            } catch (error) {
                frappe.msgprint(__("Could not save address. Please try again."));
                console.error(error);
                dialog.get_primary_btn().prop('disabled', false);
            }
        }
    });
    dialog.show();
};

yene.checkout.get_customer_addresses_for_dialog = function() {
    return new Promise((resolve, reject) => {
        frappe.call({
            method: "yene.overrides.webshop_cart.get_customer_addresses",
            callback: (r) => r.message ? resolve(r.message) : reject(r),
            error: (r) => reject(r)
        });
    });
};

// Cash or YeneHealth Credit. Switching reprices the whole cart from that
// method's price list and holds back items with no credit price; the server
// sends the cart back re-rendered, plus a message naming any held-back items.
frappe.ready(function () {
    if (!window.location.pathname || window.location.pathname.indexOf("/cart") !== 0) {
        return;
    }

    $(document).on("change", 'input[name="yene_payment_method"]', function () {
        const $inputs = $('input[name="yene_payment_method"]');
        $inputs.prop("disabled", true);

        frappe.call({
            method: "yene.overrides.credit_pricing.set_cart_payment_method",
            args: { payment_method: $(this).val() },
            freeze: true,
            callback: function (r) {
                if (r.exc || !r.message) {
                    return;
                }
                // Swapped in place rather than reloading the page, so the
                // message about held-back items stays on screen.
                $(".cart-items").html(r.message.items);
                $(".cart-tax-items").html(r.message.total);
                $(".payment-summary").html(r.message.taxes_and_totals);
            }
        }).fail(function () {
            // Refused (the server's message is already on screen): put the
            // previous choice back.
            $inputs.prop("disabled", false);
            $inputs.each(function () {
                $(this).prop("checked", $(this).closest(".yene-payment-option").hasClass("selected"));
            });
        });
    });
});
